import { memo } from 'react';

import { CloseIcon } from '@/components/icons';
import { useTour } from '@/hooks';

export type ConnectToVideoProps = {
  actionId: string;
  thumbnailUrl: string;
  url: string;
  title: string;
};

const IConnectToVideo = ({ actionId, thumbnailUrl, url, title }: ConnectToVideoProps) => {
  const { showConnectToVideo, setShowConnectToVideo } = useTour({ prefixes: [actionId] });

  if (!showConnectToVideo) return null;

  return (
    <div className="relative">
      <img
        src={thumbnailUrl}
        alt={title}
        className="w-full cursor-pointer rounded-lg"
        onClick={() => window.open(url, '_blank')}
      />
      <button className="absolute top-4 right-4 z-10 cursor-pointer" onClick={() => setShowConnectToVideo(false)}>
        <CloseIcon className="text-white" />
      </button>
    </div>
  );
};

export const ConnectToVideo = memo(IConnectToVideo) as typeof IConnectToVideo;
